import React from "react";
// Remove these imports if the CSS is already in your public/index.html
// import './bootstrap.min.css'; 
// import './style.css'; 

function Header() { // Capitalized 'H' is a React convention
  return (
    <> 
      {/* Change classNames -> className */}
      <div className="container-fluid bg-dark px-5 d-none d-lg-block">
            <div className="row gx-0">
                <div className="col-lg-8 text-center text-lg-start mb-2 mb-lg-0">
                    <div className="d-inline-flex align-items-center" style={{height: "45px"}}>
                        <small className="me-3 text-light">
                          <i className="fa fa-map-marker-alt me-2"></i>
                          Zambia, UK, South Africa & USA
                        </small>
                    </div>
                </div>
                <div className="col-lg-4 text-center text-lg-end">
                    <div className="d-inline-flex align-items-center" style={{height: "45px"}}>
                        <a className="btn btn-sm btn-outline-light btn-sm-square rounded-circle me-2" href="/"><i className="fas fa-times"></i></a>
                        {/* <a className="className btn-sm btn-outline-light btn-sm-square rounded-circle me-2" href="/"><i className="fab fa-facebook-f fw-normal"></i></a> */}
                        <a className="btn btn-sm btn-outline-light btn-sm-square rounded-circle me-2" href="/"><i className="fab fa-linkedin-in fw-normal"></i></a>
                        <a className="btn btn-sm btn-outline-light btn-sm-square rounded-circle me-2" href="/"><i className="fab fa-instagram fw-normal"></i></a>
                    </div>
                </div>
            </div>
      </div>
    </>
  );
}

export default Header;